import { NETWORK } from "./service";

export const API_DOMAIN = {
    //[NETWORK.OPDEV]: 'http://opdev-api-search.plaync.com',
    [NETWORK.OPDEV]: 'https://api-search.sb.plaync.com',
    [NETWORK.SB]: 'https://api-search.sb.plaync.com',
    [NETWORK.RC]: 'https://rc-api-search.plaync.com',
    [NETWORK.STAGE]: 'https://api-search.plaync.com',
    [NETWORK.LIVE]: 'https://api-search.plaync.com',
};

// api prefix
export const API_PREFIX = `/{serviceAlias}/search/v2`;

// api
export const API = {
    // 통합검색 api
    TOTAL: `${API_PREFIX}/total`, // 전체 검색
    POWERBOOK: `${API_PREFIX}/powerbook`, // 파워북
    FAQ: `${API_PREFIX}/faq`, // 도움말(FAQ)
    GUIDEBOOK: `${API_PREFIX}/guidebook`, // 가이드북
    DICTIONARY: `${API_PREFIX}/dictionary`, // 리니지2 사전(아이템+사전)
    CHARACTER: `${API_PREFIX}/character`, // 블소, 아이온 - 캐릭터
    GUILD: `${API_PREFIX}/guild`, // 블소 문파 / 아이온 레기온
    NPUSER: `${API_PREFIX}/npuser`, // NPUser
    VIDEO: `${API_PREFIX}/movie`, // Video
    NCTV: `${API_PREFIX}/video`, // NCTV
    EVENT: `${API_PREFIX}/promotion`, // 이벤트(프로모션)
    IMAGE: `${API_PREFIX}/image`, // 이미지
    NSHOP: `${API_PREFIX}/nshop`,
    COMMUNITY: `${API_PREFIX}/community`, // 게시글 - 외부 옵션으로 communityAPI를 주입하지 않을 시에 사용함
    TAG: `${API_PREFIX}/tag`, // 태그 - 외부 옵션으로 communityAPI를 주입하지 않을 시에 사용함
    
    // 커뮤니티 api
    COMMUNITY_BOARD_ALIAS: `{communityApi}/board/allDepthCategories?boardMetaTag=searchAllowed`, // 커뮤니티 api - 검색허용게시판 board alias 조회
    COMMUNITY_API_ALL: `{communityApi}/board/allowed/all/search/articles`, // 커뮤니티 api - 검색 허용한 게시판 전체 게시글 검색
    COMMUNITY_API_ARTICLE: `{communityApi}/board/{boardAlias}/search/articles`, // 커뮤니티 api - 특정 게시판 검색
    COMMUNITY_API_TAG: `{communityApi}/tag/search`, // 커뮤니티 api - 태그
};